"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var _logisticsTrackingNo = require("@/utils/logisticsTrackingNo");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  data: function data() {
    return {
      companyInfo: {
        transportNo: null,
        companyValue: null,
        deliveryCode: '',
        deliveryName: ''
      },
      companyOption: [],
      recognitionStatus: '',
      identifyRequestId: 0,
      companySelectVisible: false,
      lastDetectedDelivery: null,
      hasRecognizedAttempt: false
    };
  },
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    showCompany: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    showCompanySelect: function showCompanySelect() {
      return this.showCompany && this.companySelectVisible;
    },
    recognitionText: function recognitionText() {
      var textMap = {
        loading: '识别中...',
        success: '自动识别成功',
        fail: '自动识别失败',
        manual: '手动选择'
      };
      return textMap[this.recognitionStatus] || '';
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var oldVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var nextValue = val || {};
        var normalizedValue = {
          transportNo: (0, _logisticsTrackingNo.normalizeLogisticsTrackingNo)(nextValue.transportNo),
          companyValue: nextValue.companyValue || null,
          deliveryCode: nextValue.deliveryCode || '',
          deliveryName: nextValue.deliveryName || '',
          initSearch: nextValue.initSearch || ''
        };
        if (!this.isSameCompanyInfo(normalizedValue, this.companyInfo)) {
          this.companyInfo = normalizedValue;
        }
        this.syncCompanySelectVisible(normalizedValue);
        var deliveryCodeChanged = nextValue.deliveryCode !== (oldVal && oldVal.deliveryCode);
        var needsCodeSearch = nextValue && nextValue.deliveryCode && !nextValue.companyValue && deliveryCodeChanged;
        if (needsCodeSearch) {
          this.getCompanyList('');
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    this.getCompanyList();
  },
  methods: {
    throttle: _throttle.default,
    isSameCompanyInfo: function isSameCompanyInfo() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return (source.transportNo || '') === (target.transportNo || '') && (source.companyValue || '') === (target.companyValue || '') && (source.deliveryCode || '') === (target.deliveryCode || '') && (source.deliveryName || '') === (target.deliveryName || '') && (source.initSearch || '') === (target.initSearch || '');
    },
    restoreTransportCursor: function restoreTransportCursor(cursorStart) {
      var _this = this;
      var cursorEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cursorStart;
      this.$nextTick(function () {
        var inputRef = _this.$refs.transportInputRef;
        var inputEl = inputRef && inputRef.$refs ? inputRef.$refs.input : null;
        if (!inputEl || typeof inputEl.setSelectionRange !== 'function') {
          return;
        }
        if (typeof document !== 'undefined' && document.activeElement !== inputEl) {
          return;
        }
        inputEl.setSelectionRange(cursorStart, cursorEnd);
      });
    },
    emitValue: function emitValue() {
      this.$emit('input', _objectSpread({}, this.companyInfo));
    },
    syncCompanySelectVisible: function syncCompanySelectVisible() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.showCompany) {
        this.companySelectVisible = false;
        return;
      }
      var hasCompanyInfo = !!(value.companyValue || value.deliveryCode || value.deliveryName);
      if (hasCompanyInfo) {
        this.companySelectVisible = true;
        return;
      }
      if (!value.transportNo) {
        this.companySelectVisible = false;
        return;
      }
      if (this.recognitionStatus === 'fail' || this.recognitionStatus === 'success' || this.recognitionStatus === 'manual') {
        return;
      }
      this.companySelectVisible = false;
    },
    resetRecognitionState: function resetRecognitionState() {
      this.recognitionStatus = '';
      this.lastDetectedDelivery = null;
      this.hasRecognizedAttempt = false;
    },
    clearCompanySelection: function clearCompanySelection() {
      var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.companyInfo.companyValue = null;
      this.companyInfo.deliveryCode = '';
      this.companyInfo.deliveryName = '';
      if (emit) {
        this.emitValue();
      }
    },
    applyCompanySelection: function applyCompanySelection(company) {
      var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!company) {
        this.clearCompanySelection(emit);
        return;
      }
      this.companyInfo.companyValue = company.deliveryId || null;
      this.companyInfo.deliveryCode = company.deliveryCode || '';
      this.companyInfo.deliveryName = company.deliveryName || '';
      if (emit) {
        this.emitValue();
      }
    },
    resolveCompanyOption: function resolveCompanyOption() {
      var delivery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!delivery || !this.companyOption.length) {
        return null;
      }
      if (delivery.deliveryId) {
        return this.companyOption.find(function (item) {
          return item.deliveryId === delivery.deliveryId;
        }) || null;
      }
      if (delivery.deliveryCode) {
        return this.companyOption.find(function (item) {
          return item.deliveryCode === delivery.deliveryCode;
        }) || null;
      }
      if (delivery.deliveryName) {
        return this.companyOption.find(function (item) {
          return item.deliveryName === delivery.deliveryName;
        }) || null;
      }
      return null;
    },
    hasDetectedDeliveryInfo: function hasDetectedDeliveryInfo() {
      var delivery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return !!(delivery && (delivery.deliveryId || delivery.deliveryCode || delivery.deliveryName));
    },
    isSameAsDetectedCompany: function isSameAsDetectedCompany() {
      var company = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.hasRecognizedAttempt) {
        return false;
      }
      var detectedDelivery = this.lastDetectedDelivery || {};
      if (!this.hasDetectedDeliveryInfo(detectedDelivery)) {
        return false;
      }
      if (detectedDelivery.deliveryId && company.deliveryId) {
        return detectedDelivery.deliveryId === company.deliveryId;
      }
      if (detectedDelivery.deliveryCode && company.deliveryCode) {
        return detectedDelivery.deliveryCode === company.deliveryCode;
      }
      if (detectedDelivery.deliveryName && company.deliveryName) {
        return detectedDelivery.deliveryName === company.deliveryName;
      }
      return false;
    },
    updateRecognitionStatusByManualSelection: function updateRecognitionStatusByManualSelection() {
      var company = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.hasRecognizedAttempt) {
        return;
      }
      this.recognitionStatus = this.isSameAsDetectedCompany(company) ? 'success' : 'manual';
    },
    handleTransportNoInput: function handleTransportNoInput(value) {
      var inputRef = this.$refs.transportInputRef;
      var inputEl = inputRef && inputRef.$refs ? inputRef.$refs.input : null;
      var cursorStart = inputEl && typeof inputEl.selectionStart === 'number' ? inputEl.selectionStart : null;
      var cursorEnd = inputEl && typeof inputEl.selectionEnd === 'number' ? inputEl.selectionEnd : cursorStart;
      var processed = (0, _logisticsTrackingNo.normalizeLogisticsTrackingNo)(value);
      var currentTransportNo = this.companyInfo.transportNo || '';
      this.$set(this.companyInfo, 'transportNo', processed);
      if (processed !== currentTransportNo) {
        this.resetRecognitionState();
        if (this.showCompany) {
          this.companySelectVisible = false;
          this.clearCompanySelection(false);
        }
      }
      this.emitValue();
      if (processed !== value && cursorStart !== null) {
        this.restoreTransportCursor(cursorStart, cursorEnd);
      }
    },
    handleTransportNoBlur: function () {
      var _handleTransportNoBlur = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
        var value, processed;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              value = event && event.target ? event.target.value : this.companyInfo.transportNo;
              processed = (0, _logisticsTrackingNo.normalizeLogisticsTrackingNo)(value);
              this.$set(this.companyInfo, 'transportNo', processed);
              if (processed) {
                _context.n = 1;
                break;
              }
              this.resetRecognitionState();
              if (this.showCompany) {
                this.companySelectVisible = false;
                this.clearCompanySelection(false);
              }
              this.emitValue();
              return _context.a(2);
            case 1:
              this.emitValue();
              if (this.showCompany) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _context.n = 3;
              return this.identifyCompanyByNo(processed);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleTransportNoBlur(_x) {
        return _handleTransportNoBlur.apply(this, arguments);
      }
      return handleTransportNoBlur;
    }(),
    changeSelect: function changeSelect(value) {
      if (!value) {
        this.getCompanyList('');
        this.clearCompanySelection();
        if (this.hasRecognizedAttempt) {
          this.recognitionStatus = 'manual';
        }
        return;
      }
      var company = this.resolveCompanyOption({
        deliveryId: value
      });
      if (company) {
        this.applyCompanySelection(company, false);
        this.updateRecognitionStatusByManualSelection(company);
        this.emitValue();
      }
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this2 = this;
      this.throttle(function () {
        _this2.getCompanyList(data);
      }, 300)();
    },
    getCompanyList: function () {
      var _getCompanyList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var key,
          res,
          _company,
          company,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              key = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              _context2.n = 1;
              return orderListApi.getTransportAll(key);
            case 1:
              res = _context2.v;
              this.companyOption = res.list || [];
              if (!(this.value && this.value.deliveryCode && !this.value.companyValue)) {
                _context2.n = 2;
                break;
              }
              _company = this.resolveCompanyOption({
                deliveryCode: this.value.deliveryCode,
                deliveryName: this.value.deliveryName
              });
              if (_company) {
                this.applyCompanySelection(_company);
              }
              return _context2.a(2, this.companyOption);
            case 2:
              if (this.companyInfo.companyValue) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, this.companyOption);
            case 3:
              company = this.resolveCompanyOption({
                deliveryId: this.companyInfo.companyValue
              });
              if (company) {
                this.applyCompanySelection(company, false);
              }
              return _context2.a(2, this.companyOption);
          }
        }, _callee2, this);
      }));
      function getCompanyList() {
        return _getCompanyList.apply(this, arguments);
      }
      return getCompanyList;
    }(),
    identifyCompanyByNo: function () {
      var _identifyCompanyByNo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(deliveryNo) {
        var requestId, detectedDelivery, exists, company, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              requestId = ++this.identifyRequestId;
              this.recognitionStatus = 'loading';
              this.companySelectVisible = false;
              this.hasRecognizedAttempt = true;
              this.lastDetectedDelivery = null;
              _context3.p = 1;
              _context3.n = 2;
              return orderListApi.identifyTransportCompany(deliveryNo);
            case 2:
              detectedDelivery = _context3.v;
              if (!(requestId !== this.identifyRequestId)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              _context3.n = 4;
              return this.getCompanyList('');
            case 4:
              if (detectedDelivery && detectedDelivery.deliveryId) {
                exists = this.resolveCompanyOption({
                  deliveryId: detectedDelivery.deliveryId
                });
                if (!exists) {
                  this.companyOption = [detectedDelivery].concat(_toConsumableArray(this.companyOption));
                }
              }
              company = this.resolveCompanyOption(detectedDelivery);
              this.companySelectVisible = true;
              if (!company) {
                _context3.n = 5;
                break;
              }
              this.lastDetectedDelivery = {
                deliveryId: company.deliveryId || null,
                deliveryCode: company.deliveryCode || '',
                deliveryName: company.deliveryName || ''
              };
              this.applyCompanySelection(company);
              this.recognitionStatus = 'success';
              return _context3.a(2);
            case 5:
              if (detectedDelivery && (detectedDelivery.deliveryCode || detectedDelivery.deliveryName)) {
                this.lastDetectedDelivery = {
                  deliveryId: detectedDelivery.deliveryId || null,
                  deliveryCode: detectedDelivery.deliveryCode || '',
                  deliveryName: detectedDelivery.deliveryName || ''
                };
                this.companyInfo.companyValue = null;
                this.companyInfo.deliveryCode = detectedDelivery.deliveryCode || '';
                this.companyInfo.deliveryName = detectedDelivery.deliveryName || '';
                this.emitValue();
              } else {
                this.lastDetectedDelivery = null;
                this.clearCompanySelection();
              }
              this.companySelectVisible = true;
              this.recognitionStatus = 'fail';
              _context3.n = 9;
              break;
            case 6:
              _context3.p = 6;
              _t = _context3.v;
              if (!(requestId !== this.identifyRequestId)) {
                _context3.n = 7;
                break;
              }
              return _context3.a(2);
            case 7:
              _context3.n = 8;
              return this.getCompanyList('');
            case 8:
              this.companySelectVisible = true;
              this.lastDetectedDelivery = null;
              this.recognitionStatus = 'fail';
            case 9:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 6]]);
      }));
      function identifyCompanyByNo(_x2) {
        return _identifyCompanyByNo.apply(this, arguments);
      }
      return identifyCompanyByNo;
    }()
  }
};